// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminDistributors = (client) => ({
    /**
     * `POST /admin/distributors`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDistributorsCreate
     * @source apps/backend/src/api/admin/distributors/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/distributors", { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/distributors/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDistributorsIdDelete
     * @source apps/backend/src/api/admin/distributors/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/distributors/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/distributors`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDistributorsList
     * @source apps/backend/src/api/admin/distributors/route.ts
     */
    list: (query, headers) => client.fetch("/admin/distributors", { method: "GET", query, headers }),
    /**
     * `POST /admin/distributors/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDistributorsIdCreate
     * @source apps/backend/src/api/admin/distributors/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/distributors/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=distributors.js.map